let local = {
    stripe:{
        key: "pk_test_yA9h0z75Nb5gPo238gKECaGs"
    },
    bpApi:{
        endpoint: "http://localhost:5000"
    },
    firebaseConfig:{
        apiKey: "AIzaSyAjawUUzvjDQdVqlfIbfCsaHiWHNhIV0do",
        authDomain: "whenww-dev.firebaseapp.com",
        databaseURL: "https://whenww-dev.firebaseio.com",
        projectId: "whenww-dev",
        storageBucket: "whenww-dev.appspot.com",
        messagingSenderId: "883102313470",
        appId: "1:883102313470:web:7ed34b2ae06baff95beeaf",
        measurementId: "G-J53K5PDD46"
    },
    googleAnalytics:{
        id: "UA-157290356-2"
    }
};

let dev = {
    stripe:{
        key: "pk_test_yA9h0z75Nb5gPo238gKECaGs"
    },
    bpApi:{
        endpoint: "http://localhost:5000"
    },
    firebaseConfig:{
        apiKey: "AIzaSyAjawUUzvjDQdVqlfIbfCsaHiWHNhIV0do",
        authDomain: "whenww-dev.firebaseapp.com",
        databaseURL: "https://whenww-dev.firebaseio.com",
        projectId: "whenww-dev",
        storageBucket: "whenww-dev.appspot.com",
        messagingSenderId: "883102313470",
        appId: "1:883102313470:web:7ed34b2ae06baff95beeaf",
        measurementId: "G-J53K5PDD46"
    },
    googleAnalytics:{
        id: "UA-157290356-2"
    }
};

let prod = {
    stripe:{
        key: "pk_test_yA9h0z75Nb5gPo238gKECaGs"
    },
    bpApi:{
        endpoint: "http://localhost:5000"
    },
    firebaseConfig:{
        apiKey: "AIzaSyDO_o9XnwFdYIUiQhT9YcgOp3L8ousDohA",
        authDomain: "whenww-prod.firebaseapp.com",
        databaseURL: "https://whenww-prod.firebaseio.com",
        projectId: "whenww-prod",
        storageBucket: "whenww-prod.appspot.com",
        messagingSenderId: "1061082530915",
        appId: "1:1061082530915:web:b8c2be94f0f43b52a7e456",
        measurementId: "G-J2R1DWM03Z"
    },
    googleAnalytics:{
        id: "UA-158133387-1"
    }
};

const config  = () =>{
    console.log(process.env.REACT_APP_ENV);
    return process.env.REACT_APP_ENV === "prod"?prod:process.env.REACT_APP_ENV === "dev"?dev:local;
};

export default config();
